import { motion } from "framer-motion";
import classes from './WheelCounter.module.scss'
import clsx from 'clsx';
import { useRef } from "react";
import { useMediaQuery } from "@educaplay/core";
import { useSelector } from "react-redux";
    
function WheelCounter(props) {
    
    const isTouchDevice = (useMediaQuery("(hover:none)") || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0));
    const { currentBall, ballNum, specificAngle, ballMeasuraments } = props;
    const questions = useSelector(state => state.game.questions);
    const WheelRef = useRef();
    const widthBall = (((2*Math.PI*(ballMeasuraments/2)) / questions.length)-2);
    
    return (
        <>
            <div className={classes.title} style={{fontSize: 'min( '+(((ballMeasuraments/2)*55)/100)+'px , 14px )'}}>{currentBall + 1}/{ballNum}</div>
            <motion.div transition={isTouchDevice && {duration: 1}} animate={isTouchDevice && {rotate: specificAngle}} className={classes.wheel} ref={WheelRef}>
                {[...Array(ballNum)].map((a, key) => {
                    const degrees = -90 + 360 / ballNum * key;
                    
                    return (
                        
                        <div className={
                            clsx(classes.ball, (currentBall === key) && classes['ball--selected'],
                            (questions[key].answer !== null && questions[key].checkAnswer(questions[key].answer)) &&  classes['ball--correct'],
                            (questions[key].answer !== null && !questions[key].checkAnswer(questions[key].answer)) && classes['ball--wrong']
                            )} style={{width: (widthBall < 4) ? 4 : (widthBall > 8) ? 8: widthBall,transform: 'rotate(' + degrees + 'deg) translate('+(ballMeasuraments/2)+'px) rotate(' + (-degrees) + 'deg)'}} key={key}></div>
                    );
                })}
            </motion.div>
        </>
    )
}

export default WheelCounter